import { render, staticRenderFns } from "./MoreInfo.vue?vue&type=template&id=3c3284ce&scoped=true"
import script from "./MoreInfo.vue?vue&type=script&lang=js"
export * from "./MoreInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c3284ce",
  null
  
)

export default component.exports